// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"c5156124","707":"3424a9dc","729":"9ada605f"}[chunkId] + ".js";
};